import { UPDATE_BOOKING_DOCUMENT_UI } from './constants';

export const getUpdateDocumentUIKey = id => `${UPDATE_BOOKING_DOCUMENT_UI}_${id}`;
